export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"深圳市晋百慧生物有限公司（简称“晋百慧生物”）创办于2013年，总部位于中国深圳。由“孔雀计划”海外高层次人才于浩洋博士创立，秉承着“让医务人员工作更轻松，让人们生活更美好”的使命，是一家专注于体外诊断和人类健康事业的生物科技企业。"},{"name":"keywords","content":"晋百慧生物,体外诊断,肿瘤诊断,即时检测,肠癌早筛,miR-92a,睿长太,生物科技"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"}],"link":[{"rel":"icon","href":"/logo.png","type":"image/x-icon"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1","title":"晋百慧生物"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const devPagesDir = null

export const devRootDir = null